import "./loading.scss";
import { LoadingSpinner as LoadingSpinnerShared } from "@shared/src";

interface ISpinner {
  position?: "fixed" | "absolute" | "relative";
  backgroundColor?: string;
  zIndex?: number;
  positionValue?: {
    top?: number | string;
    left?: number | string;
    right?: number | string;
    bottom?: number | string;
  };
  height?: number | string;
}

/**
 * 로딩 스피너
 */
const LoadingSpinner = ({
  position = "fixed",
  backgroundColor = "rgba(255, 255, 255, 0.9)",
  zIndex,
  positionValue = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  height = "100%",
}: ISpinner) => {
  return (
    <>
      {/* <div
        className="loading-spinner"
        style={{
          position: `${position}`,
          backgroundColor: `${backgroundColor}`,
          zIndex: `${zIndex}`,
        }}
      >
        <div className="spinner">
          <span className=""></span>
        </div>
      </div> */}
      <LoadingSpinnerShared
        position={position}
        backgroundColor={backgroundColor}
        zIndex={zIndex}
        positionValue={positionValue}
        height={height}
      />
    </>
  );
};

export default LoadingSpinner;
